<template><div><h1 id="anredecode" tabindex="-1"><a class="header-anchor" href="#anredecode"><span>Anredecode</span></a></h1>
<p>Anredecode — Definiert die Anredecodes</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Definiert die möglichen Anredecodes, die in der Adressverwaltung für eine Adresse erfasst werden können.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Anredecodes</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Anredecode</dt>
<dd>Anredecode, alphanumerisch</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Anredecodes</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.anreden.html" title="Einzelanreden">Anreden</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.titel.html" title="Titel und akademischer Grad">Titel</RouteLink></p>
</div></template>


